import React, { useEffect } from 'react';
import { fetchHospital } from '@redux/hospitals/actions';
import { useDispatch, useSelector } from 'react-redux';
import { usePageActions } from '@hooks';
import { fetchPathways } from '@pathways/redux/pathways/actions';
import PathwayTitle from './PathwayTitle';
import PathwayDetailsBody from './PathwayDetailsBody';
import {
  CopyPathway,
  ShareSnapshot,
  EditPathway,
  PublishPathway,
  DeletePathway,
  CreateSnapshot,
} from './PathwayDetailsActions';
import { selectSharedPathway } from '@pathways/redux/sharedPathways/reducers';
import { fetchSharedPathwaySnapshots } from '@pathways/redux/sharedPathways/actions';

function PathwayDetails({ match }) {
  const dispatch = useDispatch();

  const pathwayId = Number(match.params.id);

  useEffect(() => {
    dispatch(fetchHospital());
    dispatch(fetchPathways());
    dispatch(fetchSharedPathwaySnapshots());
  }, [dispatch, pathwayId]);

  const { setActions, setTitle } = usePageActions({
    actions: [],
    showBack: true,
    title: '',
  });

  const pathway = useSelector(selectSharedPathway(pathwayId));

  useEffect(() => {
    setTitle(<PathwayTitle pathway={pathway} />);

    if (pathway) {
      setActions([
        <ShareSnapshot parentPathwayId={pathwayId} pathway={pathway} disabled />,
        <CreateSnapshot pathway={pathway} disabled />,
        <CopyPathway pathway={pathway} disabled />,
        <PublishPathway pathway={pathway} disabled />,
        <DeletePathway pathway={pathway} disabled />,
        <EditPathway disabled />,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathway, pathwayId]);

  return <PathwayDetailsBody pathway={pathway} isSharedPathway />;
}

export default PathwayDetails;
